import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, ArrowRight } from 'lucide-react';

const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
  { name: 'Services', path: '/services' },
  { name: 'About', path: '/about-us' },
  { name: 'Contact', path: '/contact-us' }];


  const isActive = (path) => location.pathname === path;

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
      isScrolled ? 'bg-white/80 backdrop-blur-md shadow-sm' : 'bg-transparent'}`
      }>

      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          {/* Logo */}
          <Link to="/" className="flex items-center space-x-2 group">
            <img src="/logo.png" alt="OneSource" className="h-20 w-auto" />
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-1">
            {navLinks.map((link) =>
            <Link
              key={link.name}
              to={link.path}
              className={`px-4 py-2 text-sm font-medium rounded-lg transition-all duration-200 ${
              isActive(link.path) ?
              'text-[#f9a825] bg-orange-50' :
              'text-slate-700 hover:text-slate-900 hover:bg-slate-50'}`
              }>

                {link.name}
              </Link>
            )}
            <Link
              to="/contact-us"
              className="ml-4 flex items-center space-x-2 px-5 py-2.5 bg-[#f9a825] text-white rounded-full hover:bg-[#f57c00] transition-all duration-200 font-medium text-sm group">

              <span>Get Started</span>
              <ArrowRight className="w-4 h-4 group-hover:translate-x-0.5 transition-transform duration-200" />
            </Link>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="md:hidden p-2 text-slate-700 hover:text-slate-900">

            {isMobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen &&
      <div className="md:hidden bg-white border-t border-slate-200">
          <div className="px-6 py-4 space-y-2">
            {navLinks.map((link) =>
          <Link
            key={link.name}
            to={link.path}
            onClick={() => setIsMobileMenuOpen(false)}
            className={`block py-2 text-sm font-medium transition-colors duration-200 ${
            isActive(link.path) ? 'text-[#f9a825]' : 'text-slate-700'}`
            }>

                {link.name}
              </Link>
          )}
            <Link
            to="/contact-us"
            onClick={() => setIsMobileMenuOpen(false)}
            className="inline-flex items-center space-x-2 px-5 py-2.5 bg-[#f9a825] text-white rounded-full hover:bg-[#f57c00] transition-all duration-200 font-medium text-sm mt-2">

              <span>Get Started</span>
              <ArrowRight className="w-4 h-4" />
            </Link>
          </div>
        </div>
      }
    </nav>);

};

export default Navbar;